import { rootCategories } from "../data/entity_sets/categoryTree";
import type { FaireCategoryEntity } from "@faire/playground-entity-db/entity_types/category";
import { getEntityByToken } from "../data/get_entity";

export type CategoryLevel3 = {
  id: string;
  label: string;
  href?: string;
};

export type CategoryLevel2 = {
  id: string;
  label: string;
  href?: string;
  children?: CategoryLevel3[];
};

export type CategoryLevel1 = {
  id: string;
  label: string;
  href?: string;
  children?: CategoryLevel2[];
};

const toId = (token: string): string =>
  token.replace(/^cat_/, "").replace(/_/g, "-");

const buildCategoryNode = (
  category: FaireCategoryEntity
): CategoryLevel1 | CategoryLevel2 | CategoryLevel3 => {
  const children = (category.childCategoryTokens ?? [])
    .map((token) => getEntityByToken(token, "category"))
    .filter((child): child is FaireCategoryEntity => child !== undefined)
    .map(buildCategoryNode);

  return {
    id: toId(category.token),
    label: category.name,
    href: category.href,
    children: children.length > 0 ? children : undefined,
  };
};

export const categoryTree: CategoryLevel1[] = rootCategories.map(
  (category) => buildCategoryNode(category) as CategoryLevel1
);
